import React, { useState } from 'react';
import './AdminLogin.scss';
import { FiLock, FiUser, FiEye, FiEyeOff, FiAlertCircle } from 'react-icons/fi';
import { RiHospitalLine } from 'react-icons/ri';
import { login } from '../../apis/adminAuth';

const AdminLogin = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [focusedField, setFocusedField] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!username || !password) {
            setError('Vui lòng nhập đầy đủ tên đăng nhập và mật khẩu.');
            return;
        }
        setLoading(true);
        try {
            const data = {
                username: username,
                password: password
            };
            const response = await login(data);
            if (response.success) {
                const token = response.data.accessToken;
                onLogin && onLogin(token, response.data.user);

                //     if (response.success) {
                //     const { accessToken, user } = response.data;
                //     // Lưu token
                //     localStorage.setItem('accessToken', accessToken);
                //     // Lưu role nếu cần dùng sau
                //     localStorage.setItem('userRole', user.role);

                //     // Redirect dựa trên role
                //     if (user.role === 'admin') {
                //         navigate('/admin/dashboard', { replace: true });
                //     } else {
                //         // Ví dụ client dashboard (bạn có thể đổi thành '/client/dashboard' hoặc '/')
                //         navigate('/dashboard', { replace: true });
                //     }
                // }
            } else {
                setError(response.message);
            }
            // await new Promise(resolve => setTimeout(resolve, 1500));
            // if (username === 'admin' && password === '123456') {
            //     onLogin && onLogin({ username });
            // } else {
            //     setError('Tên đăng nhập hoặc mật khẩu không chính xác.');
            // }
        } catch (err) {
            setError('Đăng nhập thất bại');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-page">
            {/* Subtle background grid pattern */}
            <div className="admin-login-bg-grid" />

            {/* Animated border wrapper */}
            <div className="admin-login-border-wrapper">
                <div className="admin-login-border-glow" />
                <div className="admin-login-card">
                    {/* Brand Header */}
                    <div className="admin-login-brand">
                        <div className="admin-login-logo">
                            <img src={require('../../images/Logo/Logo HSV_Icon.jpg')} alt="HSV Logo" style={{ width: '48px', height: 'auto', objectFit: 'contain' }} />
                        </div>
                        <div className="admin-login-brand-text">
                            <span className="admin-login-brand-name">Healthcare Solution Việt Nam</span>
                            <span className="admin-login-brand-sub">Hệ Thống Quản Lý</span>
                        </div>
                    </div>

                    <div className="admin-login-divider" />

                    {/* Title */}
                    <div className="admin-login-header">
                        <h1 className="admin-login-title">Đăng Nhập</h1>
                        <p className="admin-login-subtitle">Vui lòng đăng nhập để tiếp tục</p>
                    </div>

                    {/* Error Message */}
                    {error && (
                        <div className="admin-login-error">
                            <FiAlertCircle className="admin-login-error-icon" />
                            <span>{error}</span>
                        </div>
                    )}

                    {/* Form */}
                    <form onSubmit={handleSubmit} className="admin-login-form" noValidate>
                        <div className={`admin-login-field ${focusedField === 'username' ? 'is-focused' : ''} ${username ? 'has-value' : ''}`}>
                            <label htmlFor="al-username">Tên đăng nhập</label>
                            <div className="admin-input-wrapper">
                                <FiUser className="admin-input-icon" />
                                <input
                                    id="al-username"
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="Nhập tên đăng nhập"
                                    disabled={loading}
                                    autoComplete="username"
                                    onFocus={() => setFocusedField('username')}
                                    onBlur={() => setFocusedField(null)}
                                />
                            </div>
                        </div>

                        <div className={`admin-login-field ${focusedField === 'password' ? 'is-focused' : ''} ${password ? 'has-value' : ''}`}>
                            <label htmlFor="al-password">Mật khẩu</label>
                            <div className="admin-input-wrapper">
                                <FiLock className="admin-input-icon" />
                                <input
                                    id="al-password"
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Nhập mật khẩu"
                                    disabled={loading}
                                    autoComplete="current-password"
                                    onFocus={() => setFocusedField('password')}
                                    onBlur={() => setFocusedField(null)}
                                />
                                <button
                                    type="button"
                                    className="admin-toggle-password"
                                    onClick={() => setShowPassword(!showPassword)}
                                    tabIndex="-1"
                                    aria-label={showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
                                >
                                    {showPassword ? <FiEyeOff /> : <FiEye />}
                                </button>
                            </div>
                        </div>

                        <div className="admin-login-options">
                            <label className="admin-login-checkbox" htmlFor="al-remember">
                                <input
                                    id="al-remember"
                                    type="checkbox"
                                    checked={remember}
                                    onChange={(e) => setRemember(e.target.checked)}
                                    disabled={loading}
                                />
                                {/* <span className="admin-checkbox-custom" />
                                <span className="admin-checkbox-label">Ghi nhớ đăng nhập</span> */}
                            </label>
                            <a href="/admin/auth/forgot-password" className="admin-login-forgot">Quên mật khẩu?</a>
                        </div>

                        <button
                            type="submit"
                            className={`admin-login-button ${loading ? 'is-loading' : ''}`}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="admin-login-spinner" />
                                    <span>Đang xử lý...</span>
                                </>
                            ) : (
                                <span>Đăng Nhập</span>
                            )}
                        </button>
                    </form>

                    {/* Footer */}
                    <div className="admin-login-footer">
                        <span>Cần hỗ trợ?</span>
                        <a href="/support">Liên hệ kỹ thuật</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
